<template>
  <div>
    <a @click="dishViewRouter(row.user_key, row.business_key, row.key)" class="edit"><i class="material-icons">remove_red_eye</i></a>
    <a @click="dishEditRouter(row.user_key, row.business_key, row.key)" class="edit"><i class="material-icons">mode_edit</i></a>
    <a @click="removeInstantDish(row)"><i class="material-icons">delete</i></a>
  </div>
</template>
<script>
import * as firebase from "firebase";

export default {
  props: ["row", "nested"],
  methods: {

    // Dish edit
    dishEditRouter(userKey, businessKey, dishKey) {
      let params = { userKey, businessKey, dishKey };
      this.$router.push({ name: "DishEdit", params });
    },

    // Dish view
    dishViewRouter(userKey, businessKey, dishKey) {
      let params = { userKey, businessKey, dishKey };
      this.$router.push({ name: "DishView", params });
    },

    //Remove Instant Dish
    removeInstantDish(item) {
      firebase
        .database()
        .ref("dishes/" + item.key)
        .update({ is_instant: false })
        .then(() => {
          this.$bus.$emit("removeInstantDish", item);
        })
        .catch((error) => {});
    }
    
  },
};
</script>
<style scoped>
a {
  cursor: pointer;
  color: black !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Operations/InstantDishOpt.vue